import React, { useState } from "react";
import { useIntl } from "react-intl";
import EditRequestForm from "./EditRequestForm";
import messages from "./messages.i18n";
import { TableActionButton } from "@components/common/table";
import { Edit2 } from "@piiqtechnologies/svg-icons";
import { PeekDialog } from "@piiqtechnologies/ui-components";
import { Policy } from "@piiqtechnologies/ui-lib";
export const EditRequestButton = ({ scanRequest }) => {
    const intl = useIntl();
    const [openAddEditRequestDialog, setOpenAddEditRequestDialog] = useState(false);
    const toggleEditRequest = () => {
        setOpenAddEditRequestDialog(!openAddEditRequestDialog);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Policy, { action: "scan_request_edit" /* PolicyActions.SCAN_REQUEST_EDIT */, mode: "hide" },
            React.createElement(TableActionButton, { "aria-label": "edit", "data-testid": "edit-request", onClick: toggleEditRequest, Icon: Edit2, tooltip: intl.formatMessage(messages.actionsEditRequest) })),
        React.createElement(PeekDialog, { fullWidth: true, hasCloseIcon: true, maxWidth: "xs", open: openAddEditRequestDialog, onClose: toggleEditRequest, title: intl.formatMessage(messages.actionsEditRequest) },
            React.createElement(EditRequestForm, { scanRequest: scanRequest, handleScanUpdate: toggleEditRequest }))));
};
export default EditRequestButton;
